import { NoCareOutcome } from '../components/no-care-outcome';
import { StepFrame } from '../components/step-frame';
import { useConsumerFlow } from '../hooks/use-consumer-flow';
import { usePlanTotals } from '../hooks/use-plan-totals';
import type { ConsumerStepProps } from './step-props';

export function NoCareStep({ clientId }: ConsumerStepProps) {
  const { finish } = useConsumerFlow(clientId);
  const { selectedProjection, hasInsurance } = usePlanTotals(clientId);
  const deathBenefit = hasInsurance ? (selectedProjection?.deathBenefitWithoutCare ?? 0) : 0;

  return (
    <StepFrame
      step="no-care"
      title="What if you never need long-term care?"
      subtitle="There would be no long-term care claim."
      onBack={() => finish('review')}
      primary={{ label: 'Back to my plan', onClick: () => finish('review') }}
    >
      <NoCareOutcome deathBenefit={deathBenefit} />
    </StepFrame>
  );
}
